import { IAuthRepository } from "domain/contracts/auth.contracts";
import { httpClient } from "../axios/axios-api";
import { Logger } from "infra/logger/logger";

export class AuthRepository implements IAuthRepository {
  async token(authCode: string, codeVerifier: string): Promise<any> {
    const logger = Logger.getInstance();
    try {
      const token = await this.getToken(authCode, codeVerifier);
      
      if (!token || !token.access_token) {
        throw new Error("Token do Azure não foi obtido corretamente.");
      }
      
      const result = await httpClient.get("/auth/token", {
        headers: {
          Authorization: token.access_token,
        },
        timeout: 30000,
      });
      logger.debug("Token generated");
      return result;
    } catch (error: any) {
      console.log(error);
      logger.error("Token generation failed." + error);
      
      if (error.code === 'ECONNABORTED') {
        throw new Error("Timeout: Servidor não está respondendo. Tente novamente.");
      } else if (error.response?.status === 504) {
        throw new Error("Servidor temporariamente indisponível. Tente novamente em alguns minutos.");
      } else if (error.response?.status === 500) {
        throw new Error("Erro interno do servidor. Contate o administrador.");
      } else if (error.response?.status === 401) {
        throw new Error("Token do Azure inválido ou expirado.");
      }
      
      throw new Error("Token generation failed.");
    }
  }

  refresh(token: string | null): Promise<any> {
    const logger = Logger.getInstance();
    try {
      const result = httpClient.get("/auth/refresh", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      logger.debug("Token refreshed");
      return result;
    } catch (error) {
      logger.error("Token refresh failed." + error);
      throw new Error("Token refresh failed.");
    }
  }

  verify(token: string | null): Promise<any> {
    const logger = Logger.getInstance();
    try {
      const result = httpClient.get("/auth/verify", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      logger.debug("Token verified");
      return result;
    } catch (error) {
      logger.error("Invalid token." + error);
      throw new Error("Invalid token.");
    }
  }

  login(userName: string | null, password: string | null): Promise<any> {
    const logger = Logger.getInstance();
    try {
      const result = httpClient.post("/auth/verify", {
        email: userName,
        password: password,
      });
      logger.debug("Token validated");
      return result;
    } catch (error) {
      logger.error("Invalid token." + error);
      throw new Error("Invalid token.");
    }
  }

  private async getToken(authCode: string, codeVerifier: string): Promise<any> {
    const logger = Logger.getInstance();
    try {
      const data = new URLSearchParams();
      data.append("client_id", process.env.REACT_APP_AZURE_APP_ID as string);
      data.append("code", authCode);
      data.append(
        "redirect_uri",
        process.env.REACT_APP_AZURE_REDIRECT_URI as string
      );
      data.append("grant_type", "authorization_code");
      data.append("code_verifier", codeVerifier as string);
      const url = `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}/oauth2/v2.0/token`;
      const response = await httpClient.post(url, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      logger.debug("Token Azure returned", response);
      return response.data;
    } catch (err: any) {
      console.log(err);
      logger.error("Get Azure token." + err);
      throw new Error("Erro ao obter token do Azure: " + (err.message || err));
    }
  }
  async getProfile(token: string): Promise<any> {
    try {
      const url = "https://graph.microsoft.com/v1.0/me";
      const response = await httpClient.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (err) {
      console.log(err);
      return null;
    }
  }
}

export const authRepository = new AuthRepository();
